import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/** The query value that opens the Work panel on Studio. */
export const WORK_PANEL_PARAM = 'work';

export interface StudioWorkPanel {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

/**
 * The open state of the Work panel on Studio. It lives in the address (`?work=1`), so the old
 * Work route (`promote/promoteWork`, emails and pushes) opens Studio with the panel open, and the
 * back button closes it.
 */
export function useStudioWorkPanel(): StudioWorkPanel {
  const [searchParams, setSearchParams] = useSearchParams();
  const isOpen = searchParams.get(WORK_PANEL_PARAM) === '1';

  const open = useCallback(() => {
    setSearchParams((current) => {
      const params = new URLSearchParams(current);
      params.set(WORK_PANEL_PARAM, '1');
      return params;
    });
  }, [setSearchParams]);

  const close = useCallback(() => {
    setSearchParams(
      (current) => {
        const params = new URLSearchParams(current);
        params.delete(WORK_PANEL_PARAM);
        return params;
      },
      { replace: true }
    );
  }, [setSearchParams]);

  return { isOpen, open, close };
}
